/**
 * Wrap an input element with a quantity input custom element
 * @param {HTMLElement} element Node to wrap with quantity input
 * @returns {HTMLElement}
 */
export function quantityInputWrap(element) {
    if (!element) return;

    const quantityInput = document.createElement("quantity-input");

    // @link https://technology.blog.gov.uk/2020/02/24/why-the-gov-uk-design-system-team-changed-the-input-type-for-numbers/
    element.setAttribute("type", "text");
    element.setAttribute("inputmode", "numeric");
    element.setAttribute("pattern", "[0-9]*");

    const decrementButton = `<button type="button" value="-" data-quantity-decrement>`;
    const incrementButton = `<button type="button" value="+" data-quantity-increment>`;

    let newInput = element.cloneNode(true);

    newInput.setAttribute("data-quantity-value", "");

    quantityInput.appendChild(newInput);
    quantityInput.insertAdjacentHTML("beforeend", decrementButton);
    quantityInput.insertAdjacentHTML("beforeend", incrementButton);

    element.replaceWith(quantityInput);

    return quantityInput;
}
